export {
  default as B2BOrdersPage,
  AGENT_ORDERS_PATH,
  AGENT_ORDERS_ROUTE,
} from './OrdersPage';
